import React, {createContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import {useDispatch, useSelector} from 'react-redux';

import {fetchApplications, saveApplication,} from 'features/applications/reducers/recordsSlice';

import {activeApplicationSelector} from 'features/applications/selectors';

export const ApplicationsContext = createContext(null);

export const ApplicationsContextProvider = ({children}) => {
    const dispatch = useDispatch();

    const current = new URL(window.location.href);
    const params = new URLSearchParams(current.search);

    useEffect(() => {
        if (params.has('returnTo')) {
            const returnToUrl = params.get('returnTo');
            const url = new URL(returnToUrl);

            const application = {
                host: url.host,
                hostname: url.hostname,
                origin: url.origin,
                pathname: url.pathname,
                port: url.port,
                protocol: url.protocol,
            };

            dispatch(saveApplication(application));
        }
    }, [current.search, dispatch]);

    useEffect(() => {
        if (!params.has('returnTo')) {
            setTimeout(() => {
                dispatch(fetchApplications());
            }, 1000);
        }
    }, [current.search, dispatch]);

    const activeApplication = useSelector((state) =>
                                              activeApplicationSelector(state)
    );

    return (
        <ApplicationsContext.Provider value={{activeApplication}}>
            {children}
        </ApplicationsContext.Provider>
    );
};

ApplicationsContextProvider.propTypes = {
    children: PropTypes.object,
};
